<div [style]="'height: calc(99vh - ' + (layoutService.headerFooterHeight$ | async) + 'px)'">
  <div *ngIf="staffMenu" fxLayout="column" fxLayoutAlign="start stretch" style="height: 100%">
    <ag-staff-navigation id="staffNav" [staffMenu]="staffMenu"></ag-staff-navigation>
    <mat-progress-bar *ngIf="!pageLoaded" mode="indeterminate"></mat-progress-bar>
    <ag-iframe
      #iframe
      fxFlex
      id="i-frame"
      [url]="url"
      [printStatus]="printStatus"
      (onloaded)="pageLoaded = $event"
    ></ag-iframe>
  </div>
</div>
